(() => {
  if (window.__ynPdpRepairsReady) return;
  window.__ynPdpRepairsReady = true;

  const syncThumbnailState = (nav) => {
    nav.querySelectorAll('.js-thumb-item').forEach((thumb) => {
      thumb.setAttribute('aria-current', String(thumb.classList.contains('is-nav-selected')));
    });
  };

  const initializeThumbnails = (scope) => {
    scope.querySelectorAll('.js-thumb-carousel-nav').forEach((nav) => {
      if (nav.dataset.ynAccessibleThumbs === 'true') {
        syncThumbnailState(nav);
        return;
      }

      nav.dataset.ynAccessibleThumbs = 'true';
      syncThumbnailState(nav);

      const observer = new MutationObserver(() => syncThumbnailState(nav));
      observer.observe(nav, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  };

  const initializeProductKinds = (scope) => {
    scope.querySelectorAll('[data-yn-product-kind]').forEach((marker) => {
      const section = marker.closest('[data-section-type="product__section"]');
      if (!section) return;
      section.classList.remove(
        'yn-product-kind--bundle',
        'yn-product-kind--bag',
        'yn-product-kind--eyewear',
        'yn-product-kind--generic'
      );
      section.classList.add(`yn-product-kind--${marker.dataset.ynProductKind || 'generic'}`);
    });
  };

  const placeModelSwitchers = (scope) => {
    scope.querySelectorAll('[data-yn-model-switcher]').forEach((switcher) => {
      if (switcher.dataset.ynPlaced === 'true') return;
      const section = switcher.closest('[data-section-type="product__section"]');
      const price = section?.querySelector('#product-price');
      const installment = section?.querySelector('#product-form-installment');
      const anchor = installment || price;
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', switcher);
      switcher.dataset.ynPlaced = 'true';
    });
  };

  const localizeUnavailable = (scope) => {
    if (!(document.documentElement.lang || '').toLowerCase().startsWith('pl')) return;
    scope.querySelectorAll('.js-variant-selector option').forEach((option) => {
      option.textContent = option.textContent.replace(/\s*-\s*Unavailable\s*$/i, ' - Niedostępny');
    });
  };

  const initialize = (scope = document) => {
    initializeThumbnails(scope);
    initializeProductKinds(scope);
    placeModelSwitchers(scope);
    localizeUnavailable(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
